import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Home from './pages/Home';
import Company from './pages/Company';
import Advertisers from './pages/Advertisers';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/company" element={<Company />} />
        <Route path="/advertisers" element={<Advertisers />} />
      </Routes>
    </Router>

  );
}

export default App;
